let currentAudio = null;

export const playAudio = async (audioPath, volume = 1) => {
  try {
    // If there's a current audio playing, stop it completely before starting new one
    if (currentAudio) {
      await currentAudio.pause();
      currentAudio.currentTime = 0;
      currentAudio = null;
    }

    // Small delay to ensure previous audio is fully stopped
    await new Promise((resolve) => setTimeout(resolve, 50));

    // Create and play new audio
    const audio = new Audio(audioPath);
    audio.volume = volume;
    await audio.play();
    currentAudio = audio;
    return audio;
  } catch (error) {
    console.log("Audio playback failed:", error);
    return null;
  }
};

export const stopCurrentAudio = async () => {
  try {
    if (currentAudio) {
      await currentAudio.pause();
      currentAudio.currentTime = 0;
      currentAudio = null;
    }
  } catch (error) {
    console.log("Error stopping audio:", error);
  }
};
